import { render, staticRenderFns } from "./LockScreenNfcBadges.vue?vue&type=template&id=46af25bc&scoped=true"
import script from "./LockScreenNfcBadges.vue?vue&type=script&lang=ts"
export * from "./LockScreenNfcBadges.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46af25bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46af25bc')) {
      api.createRecord('46af25bc', component.options)
    } else {
      api.reload('46af25bc', component.options)
    }
    module.hot.accept("./LockScreenNfcBadges.vue?vue&type=template&id=46af25bc&scoped=true", function () {
      api.rerender('46af25bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/LockScreenNfcBadges.vue"
export default component.exports